// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./_source/cqsx/pages/cqsx/cmps/about/index.less
// module id = 179
// module chunks = 0